import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { PrimaryButton } from '../UI/PrimaryButton';
import { colors } from '../../styles/colors';

const ServiceContainer = styled.div`
position: relative;
overflow: hidden;

//  INCLUDED CLASSES:

.background-rectangle {
    position: absolute;
    background: ${colors.dark_blue};
    transform: rotate(45deg);
    z-index: -1;

    transition: all .5s;

    @media (min-width: 1440px) {
        height: 598px;

        right: -430px;
        top: -160px;
    }
    
    @media (min-width: 960px) and (max-width: 1439.98px) {
        height: 598px;

        right: -630px;
        top: -260px;
    }
    @media (min-width: 960px) {
        width: 1194px;
    }
    @media (min-width: 768px) and (max-width: 959.98px) {
        width: 442px;
        height: 258px;

        right: -230px;
        top: -80px;
    }
}

.width-limiter {
    display: flex;
    flex-direction: column;

    @media (min-width: 1440px) {
        padding: 18rem 6.75rem 25rem 6.75rem;
    }
    @media (min-width: 321px) and (max-width: 1439.98px) {
        padding: 18rem 6.75rem;
    }
    @media (max-width: 320px) {
        padding: 7.5rem 2rem;
    }
}

.text-container {
    display: flex;      
    margin-bottom: 7.25rem;

    @media (max-width: 320px) {
        margin-bottom: 5rem;
    }
}

.text {
    font-family: 'SF UI Text', sans-serif;
    font-weight: 400;
    line-height: 160%;
    color: ${colors.dark_blue};

    @media (min-width: 1920px) {
        font-size: 3.75rem;
        max-width: 940px;
    }
    @media (min-width: 321px) and (max-width: 1919.98px) {
        font-size: 3rem;
        max-width: 660px;
    }
    @media (max-width: 320px) {
        font-size: 2.25rem;
    }
}
.order-button {
    display: inline;
    margin: 0 auto;
}
`

export const Service = () => {

    const dispatch = useDispatch()
    const [submitDisabled, setSubmitDisabled] = useState(true)

    const [option, setOption] = useState(false)
    const [option1, setOption1] = useState(false)
    const [option2, setOption2] = useState(false)
    const [option3, setOption3] = useState(false)
    const [option4, setOption4] = useState(false)

    const state = [
        {
            text: 'Диагностика, гарантийный, постгарантийный и внеплановый ремонт',
            selected: option
        },
        {
            text: 'Регулярное техническое обслуживание техники',
            selected: option1
        },
        {
            text: 'Проектирование, развитие и производство индивидуальных решений для систем управления',
            selected: option2
        },
        {
            text: 'Конструкторские разработки, защищенные патентами',
            selected: option3
        },
        {
            text: 'Гидрофикация спецтехники',
            selected: option4
        },
    ]

    function checkDataAcceptChangeAvailable() {
        const not_empty = state.filter( option => option.selected === true ).length !== 0

        if (
            not_empty
        ) {
            setSubmitDisabled(false)
        } else {
            setSubmitDisabled(true)
        }

    }

    useEffect(() => {
        checkDataAcceptChangeAvailable()
    })

    function handleOrderButtonClick () {

        if (submitDisabled) {
            alert('Пожалуйста, выбирите один или несколько пунктов')
            return
        }

        const data = []
        state.forEach( opt => opt.selected ? data.push(opt.text) : null )

        dispatch({ type: 'SET_INCOMING_ORDER_DATA', value: data, order_type: 'SERVICES' })
        dispatch({ type: 'CONTACT_FORM_OPENED' })
    }

    return (
        <ServiceContainer>
            <div className="background-rectangle" />
            <div className='width-limiter'>
                <TextItem text='Диагностика, гарантийный, постгарантийный и внеплановый ремонт' opt={option} set={setOption} />
                <TextItem text='Регулярное техническое обслуживание техники' opt={option1} set={setOption1} />
                <TextItem text='Проектирование, развитие и производство индивидуальных решений для систем управления' opt={option2} set={setOption2} />
                <TextItem text='Конструкторские разработки, защищенные патентами' opt={option3} set={setOption3} />
                <TextItem text='Гидрофикация спецтехники' opt={option4} set={setOption4} />
                <PrimaryButton disabled={submitDisabled} className='order-button' onClick={handleOrderButtonClick} > Оставить заявку </PrimaryButton>
            </div>
        </ServiceContainer>
    )
}

function TextItem ({text, opt, set}) {
    return (
        <div className="text-container">
            <Checkbox opt={opt} set={set} />
            <p className='text'>{text}</p>
        </div>
    )
}

const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    margin-right: 6rem;

    position: relative;

    input {
        position: absolute;
        width: 3rem;
        height: 3rem;
        opacity: 0;
        cursor: pointer;
        z-index: 1;

        :checked ~ .checkmark {
            background: ${colors.white};
            border: 1px solid ${colors.dark_blue};

            svg {
                opacity: 1;
                width: 3rem;
                height: 2rem;
                transition: all .2s; 
            }
        }
    }
    .checkmark {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);

        width: 3rem;
        height: 3rem;

        border: 1px solid ${colors.blue};
        border-radius: .5rem;

        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            opacity: 0;
            width: 0;
            path {
                fill: ${colors.dark_blue};
            }
        }

    }
`;

function Checkbox ({ text, opt, set }) {
    return (
        <CheckboxContainer className='checkbox'>
            <input type='checkbox' onChange={()=> set(!opt) }  />
            <div className='checkmark'>
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.99996 6.79996L1.66662 4.46663C1.60561 4.40487 1.53294 4.35584 1.45283 4.32237C1.37273 4.2889 1.28677 4.27167 1.19996 4.27167C1.11314 4.27167 1.02719 4.2889 0.947079 4.32237C0.866972 4.35584 0.794305 4.40487 0.73329 4.46663C0.67153 4.52765 0.622496 4.60031 0.589029 4.68042C0.555563 4.76053 0.53833 4.84648 0.53833 4.9333C0.53833 5.02011 0.555563 5.10607 0.589029 5.18617C0.622496 5.26628 0.67153 5.33895 0.73329 5.39996L3.52662 8.1933C3.78662 8.4533 4.20662 8.4533 4.46662 8.1933L11.5333 1.1333C11.595 1.07228 11.6441 0.999615 11.6776 0.919508C11.711 0.839401 11.7283 0.753448 11.7283 0.666631C11.7283 0.579814 11.711 0.493861 11.6776 0.413754C11.6441 0.333647 11.595 0.26098 11.5333 0.199965C11.4723 0.138205 11.3996 0.0891702 11.3195 0.0557038C11.2394 0.0222374 11.1534 0.00500488 11.0666 0.00500488C10.9798 0.00500488 10.8939 0.0222374 10.8137 0.0557038C10.7336 0.0891702 10.661 0.138205 10.6 0.199965L3.99996 6.79996Z" fill="#002AFF" />
                </svg>
            </div>
            <p className='ckeckbox-text'>{text}</p>
        </CheckboxContainer>
    )
}